<aslib-title Text="Pedido de Empenho" SubText=" " Icon="fa fas fa-tasks"></aslib-title>
<div class="fieldRow"></div>
<br>
<div class="form-row">
  <div class="col-md-10">
    <div class="form-inline">
      <label>Data da informação:</label>
      <input class="form-control ml-3 mr-2 col-md-2" name="dataCadInfoPagto" (change)="limpar(grid)"
        (ngModelChange)="dataCadInfoPagto = $event" type="date" [ngModel]="dataCadInfoPagto">
      <button class="btn btn-primary mr-5" type="button" (click)="getHorasInfoPagto()"><em
          class="fa fa-caret-right"></em></button>

      <label>Dados para geração do PED:</label>
      <select class="form-control ml-5 mr-4 col-md-3" (change)="horaCadInfoPagtoChange()"
        [(ngModel)]="horaCadInfoPagto">
        <option value="" disabled selected>Selecione...</option>
        <option *ngFor="let item of horasCadInfoPagto" [ngValue]="item.cadastramento">{{item.nomeArquivo}} </option>
      </select>
      <button type="button" class="btn btn-primary" [disabled]="desabilitarCarregar"
        (click)="getInfoPagto(grid)">Carregar</button>
    </div>
  </div>
  <div class="col-md-2">
    <button type="button" class="btn btn-outline-primary" (click)="openModalParametros(parametros)">Exibir
      Parâmetros</button>
    <ng-template #parametros>
      <gpa-param-pagamento [modoEdicao]="false"></gpa-param-pagamento>
    </ng-template>
  </div>
</div>
<br>

<aslib-grid [hidden]="!showTabsNavigation" #grid id="grid" name="grid" headerTitle="Dados para pagamento" [(dataset)]="lista" indexColumnVisible="true"
  limit="10">
  
  <aslib-grid-column [property]="'sequencial'" [visible]="false" header="Sequencial" class="text-right" [width]="1"
    [sortable]="true" [resizable]="true"></aslib-grid-column>
  <aslib-grid-column [property]="'cnpjCpfCredor'" header="CPF/CNPJ do Credor" class="text-right" [width]="200"
    [sortable]="false" [resizable]="true">
    <ng-template #AslibGridCell let-item="item">
      <span>{{item.cnpjCpfCredor | cpf}}</span>
    </ng-template>
  </aslib-grid-column>
  <aslib-grid-column [property]="'nomeCredor'" header="Nome do Credor" class="text-left"  [sortable]="true"
    [resizable]="true"></aslib-grid-column>
    <aslib-grid-column [property]="'numeroProcessoSEI'" header="Número do Processo SEI" class="text-left" [width]="220"
    [sortable]="true" [resizable]="true">
    <ng-template #AslibGridCell let-item="item">
      <span>{{item.numeroProcessoSEI | processoSei}}</span>
    </ng-template>
  </aslib-grid-column>
  <aslib-grid-column [property]="'valorPagamento'" header="Valor" class="text-right" [width]="175"
    [sortable]="true" [resizable]="true">
    <ng-template #AslibGridCell let-item="item">
      <span>{{item.valorPagamento | currency:'BRL'}}</span>
    </ng-template>
  </aslib-grid-column>
  <aslib-grid-column [property]="'enviadoNoPED'" header="Enviado" class="text-center" [width]="70"
    [sortable]="false" [resizable]="false">
    <ng-template #AslibGridCell let-item="item">
      <div *ngIf="item.enviadoNoPED"><span class="badge badge badge-success">Sim</span></div>
      <div *ngIf="!item.enviadoNoPED"><span class="badge badge badge-danger">Não</span></div>
    </ng-template>
  </aslib-grid-column>
</aslib-grid>
<br>
<div class="form-row">
  <div class="col-md-3">
    <button (click)="enviarPED(grid)" [disabled]="desabilitarEnviar" style="margin-top: 30px;" type="submit"
      class="btn btn-primary" value="Salvar">
      <aslib-icon type="1" icon="fa fa-paper-plane"></aslib-icon>Enviar
    </button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/pagamento/pedido/pedido.component.html